import React from 'react';

const ServicesHero = () => {
  return (
    <section style={{ position: 'relative', minHeight: '90vh', overflow: 'hidden', background: '#050A12' }}>
      {/* Background */}
      <div style={{ position: 'absolute', inset: 0 }}>
        <img
          src="https://images.unsplash.com/photo-1549464650-6de5dfe5b7ff"
          alt="Cinematic aerial view of Norwegian mountain road at night with car headlights creating light trails through snow-covered landscape"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', filter: 'brightness(0.3) contrast(1.3) saturate(0.7)' }} />
        
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(5,10,18,0.6) 0%, rgba(5,10,18,0.3) 40%, rgba(5,10,18,0.9) 100%)' }} />
      </div>
      {/* Diagonal accent */}
      <div style={{
        position: 'absolute',
        bottom: '15%',
        left: '-5%',
        width: '110%',
        height: '1px',
        background: 'linear-gradient(90deg, transparent, rgba(59,111,212,0.5), transparent)',
        transform: 'rotate(2deg)'
      }} />
      <div style={{
        position: 'relative',
        zIndex: 2,
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '180px 5% 100px'
      }}>
        {/* Label */}
        <div style={{
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.6875rem',
          color: '#3B6FD4',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
          TJENESTER
        </div>

        {/* Asymmetric title */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'end' }}>
          <div>
            <h1 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(3rem, 7vw, 6rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.04em',
              lineHeight: 0.9,
              margin: '0 0 32px',
              transform: 'rotate(-1.5deg)',
              transformOrigin: 'left center'
            }}>
              ALT DU
              <br /><span style={{ color: '#3B6FD4' }}>TRENGER</span>
              <br />PÅ VEIEN
            </h1>
            <p style={{
              fontFamily: 'Lora, serif',
              fontStyle: 'italic',
              fontSize: 'clamp(1rem, 1.5vw, 1.25rem)',
              color: 'rgba(238,240,242,0.7)',
              lineHeight: 1.7,
              maxWidth: '420px'
            }}>
              Fra sanntids veikart til avansert bomkalkulator — NordPass samler alle verktøy norske sjåfører trenger i én plattform.
            </p>
          </div>

          {/* Service quick links */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {[
            { num: '01', label: 'Interaktivt Veikart', anchor: '#veikart' },
            { num: '02', label: 'Bomkalkulator', anchor: '#bomkalkulator' },
            { num: '03', label: 'Kjøretøyadministrasjon', anchor: '#kjoretoy' },
            { num: '04', label: 'Abonnementer', anchor: '#abonnement' }]?.
            map((item, i) =>
            <a
              key={i}
              href={item?.anchor}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                padding: '16px 20px',
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.06)',
                textDecoration: 'none',
                transition: 'all 200ms ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(59,111,212,0.1)';
                e.currentTarget.style.borderColor = 'rgba(59,111,212,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)';
              }}>
              
                <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem', color: '#3B6FD4' }}>{item?.num}</span>
                <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9375rem', fontWeight: 700, color: '#EEF0F2', flex: 1 }}>{item?.label}</span>
                <span style={{ color: 'rgba(138,149,163,0.4)', fontSize: '1rem' }}>→</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default ServicesHero;